var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDublicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 12.9V17.1C16.0001 20.6 14.6001 22 11.1001 22H6.90012C3.40012 22 2.00012 20.6 2.00012 17.1V12.9C2.00012 9.4 3.40012 8 6.90012 8H11.1001C14.6001 8 16.0001 9.4 16.0001 12.9Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 6.9V11.1C22.0001 14.6 20.6001 16 17.1001 16H16.0001V12.9C16.0001 9.4 14.6001 8 11.1001 8H8.00012V6.9C8.00012 3.4 9.40012 2 12.9001 2H17.1001C20.6001 2 22.0001 3.4 22.0001 6.9Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDublicateIcon);
export default __webpack_public_path__ + "static/media/dublicate-icon.fc0d2e68d5a31125e0734c4b041c4d3b.svg";
export { ForwardRef as ReactComponent };